<template>
  <div class="relative">
    <div
      v-if="busy"
      class="busy-overlay table-compact"
    />
    <DeparturesTable
      ref="calendar"
      class="--table-no-padding"
      :loading="loading"
      :trips="filteredTrips"
      show-seats-left
      show-travel-icon
    />
    <b-modal
      v-model="waitinglistModal"
      :title="$t('waitinglistTitle') + ': ' + (waitinglistTrip ? waitinglistTrip.tripname : '')"
      :hide-footer="true"
      size="lg"
    >
      <Waitinglist
        :trip="waitinglistTrip"
        @close="waitinglistModal = false"
      />
    </b-modal>
    <b-modal
      v-model="infoModal"
      body-class="info-modal"
      :hide-header="true"
      :hide-footer="true"
      size="xl"
    >
      <InfoModal
        :trip="infoTrip"
        @close="infoModal = false"
      />
    </b-modal>
  </div>
</template>

<script>
import { faCalendarAlt, faPlane, faUserFriends } from '@fortawesome/pro-duotone-svg-icons'
import scrollMixin from '@packages/scroll/mixins/scroll.mixin.js'

import calendarMixin from '@layers/web/mixins/calendar.mixin'

export default defineNuxtComponent({
  setup () {
    const { localeDate, localeDateFormat, localeDateCustomFormats } = useDate()

    return {
      localeDate,
      localeDateFormat,
      localeDateCustomFormats,
    }
  },

  mixins: [calendarMixin, scrollMixin],

  props: {
    trips: {
      type: Array,
      default: () => [],
    },

    loading: {
      type: Boolean,
      default: false,
    },

    busy: {
      type: Boolean,
      default: false,
    },

    rowLinks: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      icons: {
        faCalendarAlt,
        faPlane,
        faUserFriends,
      },

      waitinglistModal: false,
      waitinglistTrip: null,
      infoModal: false,
      infoTrip: null,
    }
  },

  computed: {
    filteredTrips () {
      return this.trips.filter(t => !!t.price)
    },
  },

  methods: {
    openWaitinglist (trip) {
      this.waitinglistModal = true
      this.waitinglistTrip = trip
    },

    openInfo (trip) {
      this.infoModal = true
      this.infoTrip = trip
    },
  },
})
</script>

<style lang="scss">
.flex-trip-table {
  @media (max-width: calc(theme('screens.md') - 1px)) {
    max-width: 450px;
    margin: auto;
  }
  .no-max-width & {
    max-width: none;
  }
}

.table-compact {
  &.--table-no-padding {
    @media (min-width: theme('screens.md')) {
      td:first-child, th:first-child,
      td:last-child, th:last-child {
        padding-left: 0px;
        padding-right: 0px;
      }
    }
  }
}
</style>
